export default "__VITE_PUBLIC_ASSET__7beaf452__"